import { FC } from 'react';
import { translate } from 'translations';
import { AutocompleteWrapper, Divider } from 'learning-panel-components';
import PrimaryCourse from './primaryCourse';
import styles from './selectPrimaryCourse.module.scss';

const SelectPrimaryCourse: FC<SelectPrimaryCourseProps> = (props: SelectPrimaryCourseProps) => {
    const {
        isPrimaryCourseSelectEnabled,
        coursesList,
        primaryCourseUuid,
        setSelectedUuid,
        primaryCourseDisplayName,
        setPrimaryCourseUuid,
        defaultSelect
    } = props;

    if (defaultSelect) {
        setPrimaryCourseUuid(coursesList.find(course => course.displayName === 'Java')?.uuid || '');
    }
    return (
        <>
            {isPrimaryCourseSelectEnabled ? (
                <div className={styles['primary-course']}>
                    <div>{translate('primaryCourse')}</div>
                    <AutocompleteWrapper
                        list={coursesList}
                        selectedUuid={
                            primaryCourseUuid === ''
                                ? coursesList.find(course => course.displayName === 'Java')?.uuid || coursesList[0].uuid
                                : primaryCourseUuid
                        }
                        setSelectedUuid={setSelectedUuid}
                        padding="0"
                    />
                </div>
            ) : (
                <>
                    <Divider color="rgba(255, 255, 255, 0.25)" />
                    <PrimaryCourse primaryCourse={primaryCourseDisplayName} />
                </>
            )}
            <Divider color="rgba(255, 255, 255, 0.25)" />
        </>
    );
};
export interface SelectPrimaryCourseProps {
    isPrimaryCourseSelectEnabled: boolean;
    coursesList: { displayName: string; uuid: string; disabled: boolean; tooltip?: string }[];
    primaryCourseUuid: string;
    setSelectedUuid: Function;
    primaryCourseDisplayName?: string;
    setPrimaryCourseUuid: Function;
    defaultSelect?: boolean;
}

export default SelectPrimaryCourse;
